import type { ComponentProps } from 'react';
import { Card, CardBody } from '@vnetwork/ui/primitives';
import { EmptyState } from '@vnetwork/ui/data';

/**
 * Page/tab-level empty state framed in a Card so it doesn't float bare in the
 * content area — matches the resource-console convention (Card › CardBody ›
 * EmptyState) used across the compute/CDN consoles. Takes the exact same props
 * as `EmptyState`.
 *
 * Use this for empties that are the ENTIRE content of a tab/route (website
 * gates like "Select a website", `data === null` "not configured", whole-tab
 * list empties). Inline empties — a `DataTable` `emptyState` prop, or an empty
 * inside a `Section`/`Card`/picker/search — keep using a bare `<EmptyState>`.
 */
export function WaapEmptyCard(props: ComponentProps<typeof EmptyState>) {
  return (
    <Card>
      <CardBody>
        <EmptyState {...props} />
      </CardBody>
    </Card>
  );
}
